// Helper function to format numbers with spaces
//
// Считаем «mobile webapp», когда мы:
//  а) реально запущены из Telegram Mini App (см. `IS_TELEGRAM` из runtime.ts)
//  б) на мобильной платформе (не desktop и не web-клиент).
// В веб-режиме на app.zero-wallet.net это всегда false — там не Telegram-
// платформа, а обычный браузер. Дополнительные mobile-optimizations вроде
// requestFullscreen / bottom-nav padding отсекаются по этому же флагу.
export const isMobileWebApp = (() => {
  try {
    if (!window.Telegram?.WebApp?.initData) return false;
    const platform = window.Telegram.WebApp.platform ?? "";
    return (
      platform !== "tdesktop" &&
      platform !== "weba" &&
      platform !== "macos" &&
      platform !== "webk" &&
      !platform.startsWith("web")
    );
  } catch {
    return false;
  }
})();

export const formatNumber = (value: string) => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const isPhoneComplete = (phone: string | undefined): boolean => {
  const strippedPhone = phone?.replace(/[^0-9]/g, "");
  return strippedPhone?.length === 11;
};

/**
 * Полноценная E.164-проверка: `+` + от 8 до 15 цифр (RU, UA, KZ, DE, US и т.д.).
 * Используем для интернационального ввода номера — там где нельзя жёстко
 * прибивать формат к российской «+7 999 999 99 99».
 */
export const isPhoneE164 = (phone: string | undefined): boolean => {
  if (!phone) return false;
  return /^\+\d{8,15}$/.test(phone.replace(/[^\d+]/g, ""));
};

/**
 * Санитайзер ввода номера: оставляет ровно один `+` в начале (если юзер
 * его поставил) и только цифры дальше. Никакой маски — юзер сам вводит
 * код страны.
 */
export const sanitizePhoneInput = (raw: string): string => {
  const hasLeadingPlus = raw.trimStart().startsWith("+");
  const digits = raw.replace(/\D/g, "");
  return (hasLeadingPlus ? "+" : "") + digits;
};

export const isCompleteCardNumber = (cardNumber: string): boolean => {
  return /^\d{16}$/.test(cardNumber.replace(/\s+/g, ""));
};

export const isValidTrc20Address = (address: string): boolean => {
  return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(address);
};

export const isValidIban = (iban: string): boolean => {
  return /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/.test(iban.replace(/\s+/g, ""));
};

export const getDeclinedWord = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
    return "бесплатных проверок";
  }

  if (lastDigit === 1) {
    return "бесплатная проверка";
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "бесплатные проверки";
  }

  return "бесплатных проверок";
};

export * from "./biometric";
